import { FormType } from "@/components/Form/types";


export const getFormsByType=(forms: SmartRxForm[],  type: FormType) => {
    return forms.filter((item: SmartRxForm) =>  item.type === type) || [];
}

export const getFormByName=(forms,  type: FormType, name: string) => {
    return forms.find((item: SmartRxForm) =>  item.type === type && item.name.toLowerCase() === name?.toLowerCase()) || {};
}

export const getFormByID=(forms,  type: FormType, id: string) => {
    return forms.find((item: SmartRxForm) =>  item.type === type && item.id.toLowerCase() === id.toLowerCase()) || {};
}